import React, {useEffect, useState} from "react";
import "../../Assets/Css/global.css";
import "../../Assets/Css/Pages/LogIn/form.css";
import {useTranslation} from "react-i18next";
import {FormProvider, useForm, useFormContext} from "react-hook-form";
// @ts-ignore
import logo from "../../Assets/Images/logo.png";
import {AuthStatusAfterFormSend} from "../../Forms/LoginForm";
import {UserType} from "../../Types/UserType";
import {Link, useLocation} from "react-router-dom";
import i18n from "i18next";
import Contractors from "./Components /Contractors";
import SaleDepartments from "./Components /SaleDepartments";
import authenticateUser from "./Services/AuthenticateUser";
import processingUserData from "./Services/ProcessingUserData";

interface FormDataInterface {
    username: string,
    password: string
};

function Form(): React.ReactElement {
    const {t} = useTranslation();
    const {register, handleSubmit, formState: { errors }} = useForm<FormDataInterface>();
    const loggedUserForm = useForm();
    const [user, setUser] = useState<UserType|null>(null);
    const [status, setStatus] = useState<any>(user ? 'logged' : null);
    const [notification, setNotification] = useState<string|null>(null);
    const [userLoginData, setUserLoginData] = useState<object>({});

    useEffect(() => {
        if (user){
            const   broadcastChannel = new BroadcastChannel('login');
                    broadcastChannel.postMessage('login');
        }
    }, [user]);

    if (!user || (user.salesDepartmentInfo.length < 2 && ((user.adminContractors.length === 1 && user.adminOtherContractors.length === 0) || (user.adminContractors.length === 0 && user.adminOtherContractors.length === 1))) || (!user.admin && user.saleDepartment.length === 1)){
        return (
            <div className={'body'} >
                <ChangeLanguage />
                <div className="login-form" >
                    <div className="logo" >
                        <img src={logo} alt="Logo" />
                    </div>

                    <div className={'form-notification'}>
                        {notification !== null ? <div className="form-error" >{notification}</div> : null }
                        <AuthStatusAfterFormSend status={status} />
                    </div>

                    <form onSubmit={handleSubmit((data: FormDataInterface) => {
                        authenticateUser(data, {
                            setUserLoginData,
                            setNotification,
                            setStatus,
                            setUser
                    })})} className={user ? 'hidden' : ''} >
                        <div className="field" >
                            <label><i className="fas fa-user" ></i>{t('layout.login-form.login')}</label>
                            {errors.username && <div className="error" >{errors.username.message}</div>}
                            <input
                                className={errors.username && 'error'}
                                {...register('username', {required: t('layout.login-form.login-error')})} />
                        </div>
                        <div className="field" >
                            <label><i className="fas fa-lock" ></i>{t('layout.login-form.password')}</label>
                            {errors.password && <div className="error" >{errors.password.message}</div>}
                            <input
                                className={errors.password && 'error'}
                                {...register('password', {required: t('layout.login-form.password-error')})} type="password" />
                        </div>

                        <div className={'register'} >
                            {t('layout.login-form.register')} <Link to={'/register'}>{t('layout.login-form.form-register')}</Link>.
                        </div>

                        <div className="button" >
                            <button className="btn" >{t('layout.login-form.login-button')}</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className={'body'} >
            <ChangeLanguage />
            <div className={'check-options'+(notification !== null ? ' max' : '')} >
                {notification ?
                    <div className={'error'} >{notification}</div>
                : null}
                <form onSubmit={loggedUserForm.handleSubmit((data: any) => {
                    processingUserData(data, {user, userLoginData, setNotification});
                })} >
                    <FormProvider {...loggedUserForm} >
                        {user.saleDepartment.length > 0 ? <SaleDepartments user={user} /> : null}
                        {user.admin && user.adminContractors.length > 0 ? <Contractors user={user} /> : null}
                    </FormProvider>

                    <div className={'button'} >
                        <button className={'btn'} >Wejdź</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

function ChangeLanguage(){
    const location = useLocation();

    function changeLanguage(language: string){
        i18n.changeLanguage(language).then(()=>{
            localStorage.setItem('i18nextLng', language);
            // window.location.reload();
        });
    }

    if (location.pathname === '/register' || location.pathname === '/login'){
        return(
            <div className={'change-language'} >
                <button className={i18n.language === 'pl-PL' ? 'active' : ''} onClick={() => changeLanguage('pl-PL')} >
                    <span className={'flag-icon flag-icon-pl'} ></span> Polski
                </button>
                <button className={i18n.language === 'en-GB' ? 'active' : ''} onClick={() => changeLanguage('en-GB')} >
                    <span className={'flag-icon flag-icon-gb'} ></span> English
                </button>
            </div>
        );
    }

    return <></>;
}

export {Form as PageLogin, ChangeLanguage};
export type {FormDataInterface};